export default __webpack_public_path__ + "src/modules/AuthModule/images/image4.svg";